import { c as _c } from "react/compiler-runtime";
import { useMemo, useRef, useState } from 'react';
import type { TermAccordionProps } from '@/app/components/sections/service/service-center/terms/types';
import { Accordion } from '@/app/components/text-and-data-display/accordion';
import { AccordionGroup } from '@/app/components/text-and-data-display/accordion-group';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const TermAccordion = t0 => {
  const $ = _c(29);
  let defaultExpandedIds;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      accordionMode: t1,
      items: t2,
      enableScrollIntoView: t3,
      defaultExpandedIds,
      testId: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = defaultExpandedIds;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    defaultExpandedIds = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  const accordionMode = t1 === undefined ? "individual" : t1;
  let t5;
  if ($[7] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const items = t5;
  const enableScrollIntoView = t3 === undefined ? false : t3;
  const testId = t4 === undefined ? "terms" : t4;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {};
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const accordionRefs = useRef(t6);
  let t7;
  bb0: {
    if (defaultExpandedIds === null) {
      let t8;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = [];
        $[10] = t8;
      } else {
        t8 = $[10];
      }
      t7 = t8;
      break bb0;
    }
    if (!defaultExpandedIds || defaultExpandedIds.length === 0) {
      let t8;
      if ($[11] !== items[0]) {
        t8 = items[0]?.id ? [items[0].id] : [];
        $[11] = items[0];
        $[12] = t8;
      } else {
        t8 = $[12];
      }
      t7 = t8;
      break bb0;
    }
    t7 = defaultExpandedIds;
  }
  const expandedIds = t7;
  const [openIds, setOpenIds] = useState(expandedIds);
  let t8;
  if ($[13] !== enableScrollIntoView) {
    t8 = value => {
      if (!value) {
        return;
      }
      setOpenIds(prev => {
        const newOpenIds = prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value];
        if (enableScrollIntoView && !prev.includes(value)) {
          const targetElement = accordionRefs.current[value];
          if (targetElement) {
            requestAnimationFrame(() => {
              targetElement.scrollIntoView({
                behavior: "smooth"
              });
            });
          }
        }
        return newOpenIds;
      });
    };
    $[13] = enableScrollIntoView;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const onToggle = t8;
  const renderContent = _temp;
  const t9 = `${testId}-items`;
  let t10;
  if ($[15] !== t9) {
    t10 = createDataAttributes({
      test: t9
    });
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== accordionMode || $[18] !== enableScrollIntoView || $[19] !== expandedIds || $[20] !== items || $[21] !== onToggle || $[22] !== openIds || $[23] !== testId) {
    t11 = accordionMode === "group" ? <AccordionGroup data={items.map(item => ({
      title: item.title,
      value: item.id,
      content: renderContent(item?.content)
    }))} defaultValue={expandedIds[0]} className="space-y-4" wrapperClassName="rounded-base-md overflow-hidden" /> : items.map((item_0, index) => {
      const isOpen = openIds.includes(item_0.id);
      return <Accordion key={item_0.id} ref={el => {
        accordionRefs.current[item_0.id] = el;
      }} title={item_0.title} value={item_0.id} isOpen={isOpen} onChange={onToggle} wrapperClassName={cn("rounded-base-md overflow-hidden", {
        "scroll-mt-16": enableScrollIntoView
      })} content={renderContent(item_0?.content)} {...createDataAttributes({
        test: `${testId}-item-${index}`
      })} />;
    });
    $[17] = accordionMode;
    $[18] = enableScrollIntoView;
    $[19] = expandedIds;
    $[20] = items;
    $[21] = onToggle;
    $[22] = openIds;
    $[23] = testId;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== props || $[26] !== t10 || $[27] !== t11) {
    t12 = <div className="space-y-4" {...t10} {...props}>{t11}</div>;
    $[25] = props;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
function _temp(content) {
  if (!content) {
    return null;
  }
  if (typeof content === "string") {
    return <div className="text-body-1-fixed where-ul:list-ul where-ul:text-gray-700 where-span:text-inline-wrap where-ol:list-ol space-y-2" dangerouslySetInnerHTML={{
      __html: content
    }} />;
  }
  return content;
}